import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastProvider } from "./components/Toast/ToastContext";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout/Layout";
import Login from "./pages/Login/Login";
import DoiMatKhau from "./pages/DoiMatKhau/DoiMatKhau";
import Dashboard from "./pages/Dashboard/Dashboard";
import DiemDanh from "./pages/DiemDanh/DiemDanh";
import NhapDiem from "./pages/NhapDiem/NhapDiem";
import QuanLyHocSinh from "./pages/QuanLyHocSinh/QuanLyHocSinh";
import QuanLyNguoiDung from "./pages/QuanLyNguoiDung/QuanLyNguoiDung";
import CaiDat from "./pages/CaiDat/CaiDat";
import StudentProfile from "./pages/StudentProfile/StudentProfile";
import DanhGiaCuoiKy from "./pages/DanhGiaCuoiKy/DanhGiaCuoiKy";
import "./index.css";

const App = () => (
  <BrowserRouter>
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/doi-mat-khau" element={<DoiMatKhau />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/diem-danh" element={<DiemDanh />} />
              <Route path="/nhap-diem" element={<NhapDiem />} />
              <Route path="/quan-ly-hoc-sinh" element={<QuanLyHocSinh />} />
              <Route path="/quan-ly-nguoi-dung" element={<QuanLyNguoiDung />} />
              <Route path="/cai-dat" element={<CaiDat />} />
              <Route path="/hoc-sinh/:id" element={<StudentProfile />} />
              <Route path="/danh-gia-cuoi-ky" element={<DanhGiaCuoiKy />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </BrowserRouter>
);

export default App;